import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ClientService } from '../../../../services/clients';
import { VisaClientsService } from '../../../../services/visaclients';
@Component({
  selector: 'app-createvisaclient',
  templateUrl: './createvisaclient.component.html',
  styleUrl: './createvisaclient.component.scss'
})
export class CreatevisaclientComponent {


  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  type: string = 'text';

  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _visaClients: VisaClientsService,
    private router: Router,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";
    this.contentReady = true;
    this.initForm();
    this.route.queryParams.subscribe(params => {
      if (params["id"]) {
        this.isUpdatePage = true;
        this.editId = params["id"];
        // ✨ املا النموذج من params
        this.data.patchValue({
          name: params["name"] || '',
          job: params["job"] || '',
          phone: params["phone"] || '',
          paid: params["paid"] ?? 0,
          remaining: params["remaining"] ?? 0,
          representative: params["representative"] || '',
          representative_account: params["representative_account"] || '',
          notes: params["notes"] || '',
          type: params["type"] ?? "0" // enum 0 أو 1
        });

      }
    });


  }

  initForm() {
    this.data = this.fb.group({
      name: ['', Validators.required],
      job: [''],
      phone: [''],                       // ممكن تضيف Pattern للموبايل لو حابب
      paid: [null, [Validators.min(0)]],
      remaining: [null, [Validators.min(0)]],
      representative: [''],
      representative_account: [''],
      notes: [''],
      type: ["", [Validators.required]]   // enum: 0 أو 1
    });
  }

  appendPostDtata() {
    this.dataForm = new FormData();
this.dataForm.append('name', this.data.get('name')?.value);
  this.dataForm.append('job', this.data.get('job')?.value);
  this.dataForm.append('phone', this.data.get('phone')?.value);
  this.dataForm.append('paid', this.data.get('paid')?.value);
  this.dataForm.append('remaining', this.data.get('remaining')?.value);
  this.dataForm.append('representative', this.data.get('representative')?.value);
   this.dataForm.append('representative_account', this.data.get('representative_account')?.value);
  this.dataForm.append('type', this.data.get('type')?.value);
  this.dataForm.append('notes', this.data.get('notes')?.value);
  
  }





  onSubmit() {
    this.appendPostDtata();
    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = true;
    this._visaClients.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء العميل" : 'Client created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = '/visaclients';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل إنشاء العميل" : 'Client not created',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }

  onEdit() {
    this.appendPostDtata();
    this.contentReady = true;
    this._visaClients.update(this.editId, this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل العميل" : 'Client updated',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = '/visaclients';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل العميل" : 'Client not updated',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }





}
